import React, { useState } from 'react';
import { Link } from 'gatsby';
import RandomLogo from '../../static/assets/Rlogo.svg';
import * as styles from '../styles/mobnavbar.module.css';

function MobNavBar() {
  const [menu, showMenu] = useState(false);

  return (
    <nav id="mobile__nav" className={styles.mobNav}>
      <Link className={styles.logo} to='/'><img src={RandomLogo} alt="Logo" /></Link>
      <div role="button" tabIndex="0" onMouseDown={() => showMenu(!menu)} className={styles.burgerIcon}>
        <div />
        <div />
        <div />
      </div>

      <div style={menu ? { transform: "translateX(0)" } : { transform: "translateX(100%)" }}
        className={styles.navLinkContainer}>
        <Link
          className={styles.links}
          to='/'>inicio
        </Link>
        <Link
          className={styles.links2}
          to='/works'>trabajos
        </Link>
        <Link
          className={styles.links}
          to='/contact'>contacto
        </Link>
      </div>
    </nav >
  );
}

export default MobNavBar;